import type { EntitleError } from "utils/errors/entitleError";

import { useMemo } from "react";
import InvalidCsrfError from "utils/errors/invalidCsrfTokenError";
import NewVersionError from "utils/errors/newVersionError";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isCSRFError(error: any, statusCode?: number): boolean {
  return Boolean(
    error && (error.status === 403 || error.statusCode === 403 || statusCode === 403) && error.message.includes("CSRF"),
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useNormalizedError = (error: any) => {
  return useMemo<EntitleError | Error | null>(() => {
    if (
      error
      && (error.message.includes("Failed to fetch dynamically imported module:")
        || error.message.includes("Importing a module script failed"))
    ) {
      return new NewVersionError();
    }

    if (isCSRFError(error)) {
      return new InvalidCsrfError();
    }
    return error as Error;
  }, [error]);
};
